import $ from 'jquery';
import { initRouter } from './router';
import * as Sentry from '@sentry/browser';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap4-toggle';
import 'bootstrap4-toggle/css/bootstrap4-toggle.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css';
import 'video.js/dist/video-js.min.css';
import { editorLoader, editorConfig } from '~config';
import LazyLoad from 'vanilla-lazyload';

Sentry.init({
  dsn: process.env.BUGSINK_URL,
  debug: false,
  sendDefaultPii: true,
  integrations: [],
  tracesSampleRate: 0,
  beforeSend(event) {
    if (
      window.origin.includes('localhost') ||
      window.origin.includes('gitpod')
    ) {
      console.log('[Bugsink] Event captured (not sent in dev):', event);
      return null;
    }
    return event;
  },
});

window.urlParams = new URLSearchParams(window.location.search);

Object.assign(window, { editorLoader, editorConfig });

window.lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy',
});

$(function () {
  initRouter();
  window.lazyLoadInstance.update();
});
